import styled from '@emotion/styled';

const Grow = styled.div`
  flex-grow: ${({ flexGrow }) => flexGrow || 1};
`;

export default Grow;
